import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const user = () => {
  return JSON.parse(localStorage.getItem('cars')) ?? false;
};

export const parseNum = (n) => {
  if(0 <= n && n < 10000){
    return n;
  } else if(10000 <= n && n < 1000000) {
    return (Math.floor(n / 1000)) + 'K';
  } else if(1000000 <= n) {
    return (Math.floor(n / 1000000)) + 'M';
  } 
};